<template>
  <div class="wx-qrcode-login">
    <div id="login-qrcode" class="qrcode"></div>
    <div class="phone-login-box" @click="gotoAccountLogin">
      <img class="phone-icon" src="https://o.666visa.cn/static/ssqwxa/register/phone-icon.png" />
      <div class="phone-label">手机号登录</div>
    </div>
  </div>
</template>
<script>
import Http from '@/libs/http';

export default {
  name: 'wx-qrcode-login',
  data() {
    return {};
  },
  mounted() {
    this.initQrcode();
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleWxLogin);
  },
  methods: {
    initQrcode() {
      if (!window.WxLogin) return;
      this.obj = new WxLogin({
        self_redirect: true,
        id: 'login-qrcode',
        appid: 'wx2f5902e63cbd7ec8',
        scope: 'snsapi_login',
        redirect_uri: encodeURIComponent('https://h5.666visa.cn/#/wx-login-callback'),
        state: '',
        style: '',
        href: 'data:text/css;base64,LmltcG93ZXJCb3ggLndycF9jb2Rle2ZvbnQtc2l6ZTogMDt9DQouaW1wb3dlckJveCAucXJjb2RlIHt3aWR0aDogMjEwcHg7Ym9yZGVyOiAxcHggc29saWQgI0U5RUVGMjttYXJnaW4tdG9wOiAwO30NCi5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9DQouaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDI1MHB4O30NCi5pbXBvd2VyQm94IC5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZTt9DQouaW1wb3dlckJveCAuc3RhdHVzIHt0ZXh0LWFsaWduOiBjZW50ZXI7Zm9udC1zaXplOiAxNnB4O2NvbG9yOiAjOTE5OTlGO3BhZGRpbmc6IDEycHggMHB4O30gDQouaW1wb3dlckJveCAuc3RhdHVzIHB7Zm9udC1zaXplOiAxNHB4O2xpbmUtaGVpZ2h0OjIycHg7fQ==',
      });
      window.removeEventListener('message', this.handleWxLogin);
      window.addEventListener('message', this.handleWxLogin);
    },
    handleWxLogin(e) {
      if (e.data && e.data.type === 'wx-login') {
        const code = e.data.code;
        // 没有code，就重新登陆去
        if (!code) {
          this.initQrcode();
          return;
        }

        Http.post('/sys/peer_login', { wx_code: code, login_type: 3 }).then((data) => {
          this.$emit('login-success', data);
        }).catch((e) => {
          if (e) console.log(e);
          this.initQrcode();
        });
      }
    },
    gotoAccountLogin() {
      this.$emit('change-page', 2);
    },
  },
};
</script>
<style lang="less" scoped>
.wx-qrcode-login{
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #2F333D;
  font-size: 14px;
  line-height: 1;
  #login-qrcode{
    margin-top: -10px;
    height: 300px;
    overflow: hidden;
  }
  .phone-login-box{
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    .phone-icon{
      width: 48px;
      height: 48px;
    }
    .phone-label{
      margin-top: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/login/components/wx-qrcode-login.vue